import { render } from "./SeSnackbarText.vue?vue&type=template&id=2dea7f39&ts=true"
import script from "./SeSnackbarText.vue?vue&type=script&lang=ts"
export * from "./SeSnackbarText.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__